import React from 'react'

const PropertyROICalculator = ({ roi_calculator }) => {
    return (
        <div>
            <div className="wg-property box-overview">
                <div className="wg-title text-11 fw-6 text-color-heading">
                    ROI Calculator
                </div>
                <div className="row">
                    {roi_calculator.map((item, index) => (
                        <div key={index} className="wrap-box col-sm-6 col-md-4 col-lg-4 pt-4">
                            <div className="box-icon">
                                <div className={`icons ${item.icon}`} />
                                <div className="content">
                                    <div className="text-4 text-color-default">{item.label}</div>
                                    <div className="text-1 text-color-heading">{item.value}</div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
                {/* <span className="tf-btn bg-color-primary pd-21 fw-6">Ask a question</span> */}
            </div>
        </div>
    );
};

export default PropertyROICalculator;




// import React from 'react'

// const WgProperty = () => {
//     return (
//         <div>
//             <div className="wg-property box-overview">
//                 <div className="heading flex justify-between">
//                     <div className="title text-5 fw-6 text-color-heading">
//                         Elegant studio flat
//                     </div>
//                     <div className="price text-5 fw-6 text-color-heading">
//                         $250,00
//                         <span className="h5 lh-30 fw-4 text-color-default">/month</span>
//                     </div>
//                 </div>
//                 <div className="info flex justify-between">
//                     <div className="feature">
//                         <p className="location text-1 flex items-center gap-10">
//                             <i className="icon-location"></i>102 102 Ingraham St, Brooklyn, NY 11237
//                         </p>
//                         <ul className="meta-list flex">
//                             <li className="text-1 flex"><span>3</span>Bed</li>
//                             <li className="text-1 flex"><span>3</span>Bath</li>
//                             <li className="text-1 flex"><span>4,043</span>Sqft</li>
//                         </ul>
//                     </div>
//                     <div className="action">
//                         <ul className="list-action">
//                             <li><span><svg width="18" height="18" viewBox="0 0 18 18" fill="none"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <path
//                                     d="M15.75 6.1875C15.75 4.32375 14.1758 2.8125 12.234 2.8125C10.7828 2.8125 9.53625 3.657 9 4.86225C8.46375 3.657 7.21725 2.8125 5.76525 2.8125C3.825 2.8125 2.25 4.32375 2.25 6.1875C2.25 11.6025 9 15.1875 9 15.1875C9 15.1875 15.75 11.6025 15.75 6.1875Z"
//                                     stroke="#5C5E61" strokeWidth="1.5" strokeLinecap="round"
//                                 />
//                             </svg>
//                             </span></li>
//                             <li><span><svg width="18" height="18" viewBox="0 0 18 18" fill="none"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <path
//                                     d="M5.625 15.75L2.25 12.375M2.25 12.375L5.625 9M2.25 12.375H12.375M12.375 2.25L15.75 5.625M15.75 5.625L12.375 9M15.75 5.625H5.625"
//                                     stroke="#5C5E61" strokeWidth="1.5" strokeLinecap="round"
//                                 />
//                             </svg>
//                             </span></li>
//                             <li><span><svg width="18" height="18" viewBox="0 0 18 18" fill="none"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <path
//                                     d="M5.04 10.3718C4.86 10.3943 4.68 10.4183 4.5 10.4438M5.04 10.3718C7.66969 10.0418 10.3303 10.0418 12.96 10.3718M5.04 10.3718L4.755 13.5M12.96 10.3718C13.14 10.3943 13.32 10.4183 13.5 10.4438M12.96 10.3718L13.245 13.5L13.4167 15.3923C13.4274 15.509 13.4136 15.6267 13.3762 15.7378C13.3388 15.8489 13.2787 15.951 13.1996 16.0376C13.1206 16.1242 13.0244 16.1933 12.9172 16.2407C12.8099 16.288 12.694 16.3125 12.5767 16.3125H5.42325C4.92675 16.3125 4.53825 15.8865 4.58325 15.3923L4.755 13.5M4.755 13.5H3.9375C3.48995 13.5 3.06072 13.3222 2.74426 13.0057C2.42779 12.6893 2.25 12.2601 2.25 11.8125V7.092C2.25 6.28125 2.826 5.58075 3.62775 5.46075C4.10471 5.3894 4.58306 5.32764 5.0625 5.2755M13.2435 13.5H14.0618C14.2834 13.5001 14.5029 13.4565 14.7078 13.3718C14.9126 13.287 15.0987 13.1627 15.2555 13.006C15.4123 12.8493 15.5366 12.6632 15.6215 12.4585C15.7063 12.2537 15.75 12.0342 15.75 11.8125V7.092C15.75 6.28125 15.174 5.58075 14.3723 5.46075C13.8953 5.38941 13.4169 5.32764 12.9375 5.2755M12.9375 5.2755C10.3202 4.99073 7.67978 4.99073 5.0625 5.2755M12.9375 5.2755V2.53125C12.9375 2.0655 12.5595 1.6875 12.0938 1.6875H5.90625C5.4405 1.6875 5.0625 2.0655 5.0625 2.53125V5.2755M13.5 7.875H13.506V7.881H13.5V7.875ZM11.25 7.875H11.256V7.881H11.25V7.875Z"
//                                     stroke="#5C5E61" strokeWidth="1.5" strokeLinecap="round"
//                                 />
//                             </svg>
//                             </span></li>
//                             <li><span><svg width="18" height="18" viewBox="0 0 18 18" fill="none"
//                                 xmlns="http://www.w3.org/2000/svg">
//                                 <path
//                                     d="M5.41251 8.18028C5.23091 7.85351 4.94594 7.5963 4.60234 7.44902C4.25874 7.30173 3.87596 7.27271 3.51408 7.36651C3.1522 7.46032 2.83171 7.67163 2.60293 7.96728C2.37414 8.26293 2.25 8.62619 2.25 9.00003C2.25 9.37387 2.37414 9.73712 2.60293 10.0328C2.83171 10.3284 3.1522 10.5397 3.51408 10.6335C3.87596 10.7273 4.25874 10.6983 4.60234 10.551C4.94594 10.4038 5.23091 10.1465 5.41251 9.81978M5.41251 8.18028C5.54751 8.42328 5.62476 8.70228 5.62476 9.00003C5.62476 9.29778 5.54751 9.57753 5.41251 9.81978M5.41251 8.18028L12.587 4.19478M5.41251 9.81978L12.587 13.8053M12.587 4.19478C12.6922 4.39288 12.8358 4.56803 13.0095 4.70998C13.1832 4.85192 13.3834 4.95782 13.5985 5.02149C13.8135 5.08515 14.0392 5.1053 14.2621 5.08075C14.4851 5.0562 14.7009 4.98745 14.897 4.87853C15.093 4.7696 15.2654 4.62267 15.404 4.44634C15.5427 4.27001 15.6448 4.06781 15.7043 3.85157C15.7639 3.63532 15.7798 3.40937 15.751 3.18693C15.7222 2.96448 15.6494 2.75 15.5368 2.55603C15.3148 2.17378 14.9518 1.89388 14.5256 1.77649C14.0995 1.6591 13.6443 1.71359 13.2579 1.92824C12.8715 2.1429 12.5848 2.50059 12.4593 2.92442C12.3339 3.34826 12.3797 3.80439 12.587 4.19478ZM12.587 13.8053C12.4794 13.9991 12.4109 14.2121 12.3856 14.4324C12.3603 14.6526 12.3787 14.8757 12.4396 15.0888C12.5005 15.3019 12.6028 15.501 12.7406 15.6746C12.8784 15.8482 13.0491 15.993 13.2429 16.1007C13.4367 16.2083 13.6498 16.2767 13.87 16.302C14.0902 16.3273 14.3133 16.309 14.5264 16.2481C14.7396 16.1872 14.9386 16.0849 15.1122 15.9471C15.2858 15.8092 15.4306 15.6386 15.5383 15.4448C15.7557 15.0534 15.8087 14.5917 15.6857 14.1613C15.5627 13.7308 15.2737 13.3668 14.8824 13.1494C14.491 12.932 14.0293 12.879 13.5989 13.002C13.1684 13.125 12.8044 13.4139 12.587 13.8053Z"
//                                     stroke="#5C5E61" strokeWidth="1.5" strokeLinecap="round"
//                                 />
//                             </svg>
//                             </span></li>
//                         </ul>
//                     </div>
//                 </div>
//                 <div className="info-detail ">
//                     <div className="wrap-box">
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-HouseLine"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">ID:</div>
//                                 <div className="text-1 text-color-heading">2297</div>
//                             </div>
//                         </div>
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Bathtub"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Bathrooms:</div>
//                                 <div className="text-1 text-color-heading">2 Rooms</div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="wrap-box">
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-SlidersHorizontal"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Type:</div>
//                                 <div className="text-1 text-color-heading">Hourse</div>
//                             </div>
//                         </div>
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Crop"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Land Size:</div>
//                                 <div className="text-1 text-color-heading">2,000 SqFt</div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="wrap-box">
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Garage-1"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Garages</div>
//                                 <div className="text-1 text-color-heading">1</div>
//                             </div>
//                         </div>
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Hammer"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Year Built:</div>
//                                 <div className="text-1 text-color-heading">2023</div>
//                             </div>
//                         </div>
//                     </div>
//                     <div className="wrap-box">
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Bed-2"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Bedrooms:</div>
//                                 <div className="text-1 text-color-heading">2 Rooms</div>
//                             </div>
//                         </div>
//                         <div className="box-icon">
//                             <div className="icons">
//                                 <i className="icon-Ruler"></i>
//                             </div>
//                             <div className="content">
//                                 <div className="text-4 text-color-default">Size:</div>
//                                 <div className="text-1 text-color-heading">900 SqFt</div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <span className="tf-btn bg-color-primary pd-21 fw-6">Ask a question</span>
//             </div>
//         </div>
//     )
// }

// export default WgProperty